module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": _vm.name,
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "startIndex",
      attrs: {
        "data-target": ("#" + _vm.name),
        "data-slide-to": index
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "item",
      class: index == _vm.startIndex ? 'active' : ''
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "alt": item.text
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption"
    }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")])])
  })), _vm._v(" "), _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": ("#" + _vm.name),
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": ("#" + _vm.name),
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "fa fa-angle-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41f80c54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VACarousel.vue
// module id = 506
// module chunks = 1